import React, { useState } from "react";

import classNames from "classnames";

import "./back-button.scss";
import { ReactComponent as ArrowBackIcon } from "./back.svg";

interface IBackButtonProps {
  className?: string;
}

export const BackButton: React.FC<IBackButtonProps> = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleBackButtonClick = () => {
    if (isLoading) {
      return;
    }

    if (!window.loginRestartFlowUrl) {
      return;
    }

    setIsLoading(true);
    window.location.replace(window.loginRestartFlowUrl);
  };

  return (
    <div
      className={classNames("back-button", className)}
      onClick={handleBackButtonClick}
    >
      <ArrowBackIcon />
    </div>
  );
};
